import { useState } from 'react';
import {
  Select,
  SelectChangeEvent,
  Box,
  MenuItem,
  FormControl,
  AlertColor,
  Typography,
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../redux';
import {
  IndTabRilePropsTablesForSelectedDatasets,
  TabTilPropsSelectedDatasetList,
} from '../../../redux/TabTile/TabTilePropsInterfaces';
import { IndChartPropProperties } from '../../../redux/ChartPoperties/ChartPropertiesInterfaces';
import { fontSize } from '../../..';
import {
  setOldSeletedDataset,
  setSelectedDsInTile,
  setSelectedTableInTile,
} from '../../../redux/ChartPoperties/ChartPropertiesActions';
import { IGetDatasetResponse } from '../../../api/types/dataset';
import { ICalculationInfo } from '../../../redux/Calculations/CurrentCalculationSessionInterface';
import { checkIfMissingColumn, updateSampleRecords } from '../../CommonFunctions/CommonFunctions';
import { getColumnTypes, getTableData } from '../../../api';
import { useLocation, useSearchParams } from 'react-router-dom';
import { NotificationDialog } from '../../CommonFunctions/DialogComponents';
import { callQueryAPI } from '../../../redux/ChartPoperties/ChartControlsActions';

const Dataset = ({ Color }: { Color?: string }) => {
  const { tabTileProps, chartProperties, savedCalculations } = useSelector((state: RootState) => ({
    tabTileProps: state.tabTileProps,
    chartProperties: state.chartProperties,
    savedCalculations: state.calculations.savedCalculations,
  }));
  const dispatch = useDispatch();

  const location = useLocation();
  const state = location.state;
  const [searchParams] = useSearchParams();
  const workspaceId = searchParams.get('workspaceId');

  const [openAlert, setOpenAlert] = useState(true);
  const [QueryErrorMessage, setQueryErrorMessage] = useState('');
  const [severity, setSeverity] = useState<AlertColor>('success');

  var propKey: string = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;

  var selectedChartProp: IndChartPropProperties = chartProperties.properties[propKey];
  let sampleRecordsStored = sessionStorage.getItem('sampleRecords');
  let sampleRecords = sampleRecordsStored ? JSON.parse(sampleRecordsStored) : {};

  const showAlert = (message: string, severity: AlertColor) => {
    setQueryErrorMessage(message);
    setSeverity(severity);
    setOpenAlert(true);
    setTimeout(() => {
      setOpenAlert(false);
    }, 3000);
  };

  const handleChange = (event: SelectChangeEvent) => {
    const value = event.target.value;
    var dsObj = tabTileProps.selectedDataSetList.filter(
      (ds: TabTilPropsSelectedDatasetList) => ds.id === value,
    )[0];
    // console.log(selectedChartProp.selectedDs?.id);
    // console.log(dsObj.id);
    // console.log(propKey);
    dispatch(setOldSeletedDataset(propKey, selectedChartProp.selectedDs));
    dispatch(setSelectedDsInTile(propKey, dsObj));
    handleTableChange(
      tabTileProps.tablesForSelectedDataSets[dsObj.id][0],
      dsObj.isExtract || dsObj.isFlatFileData,
      dsObj.id,
      savedCalculations?.length > 0
        ? savedCalculations
            ?.filter(
              (calculation) =>
                !calculation?.isAggregated &&
                calculation?.tableId === tabTileProps.tablesForSelectedDataSets[dsObj.id][0].id,
            )
            ?.map((calculation) => calculation?.calculationInfo)
        : [],
      dsObj.connectionId,
    );
  };

  const handleTableChange = async (
    table:
      | IGetDatasetResponse['dataSchema']['tables'][0]
      | IndTabRilePropsTablesForSelectedDatasets,
    isExtract?: boolean,
    dsUid?: string,
    savedNonAggregatedCalculations?: ICalculationInfo[],
    dcConnId?: string,
    _propKey?: string,
  ) => {
    console.log('Dataset.tsx');
    let value = 0;
    // modify axis fields for chart
    // const chartAxes = chartProperties.properties[propKey].chartAxes;
    // const newChartAxes = await Promise.all(
    //   chartAxes.map(async (axis: any) => {
    //     axis.fields = await Promise.all(
    //       axis.fields.map(async (field: any) => {
    //         if (field.isCalculatedField) {
    //           const calculation = savedCalculations.find(
    //             (calc: any) =>
    //               calc.uuid === field.SavedCalculationUUID &&
    //               calc.datasetId === selectedChartProp.selectedDs.id,
    //           );
    //           if (!calculation) {
    //             return { ...field, isMissing: true };
    //           }
    //           return { ...field, isMissing: false };
    //         } else {
    //           const res = await checkIfMissingColumn(
    //             field,
    //             selectedChartProp.selectedDs,
    //             tabTileProps.tablesForSelectedDataSets[selectedChartProp.selectedDs.id],
    //             // field.originalDataSetId !== selectedChartProp.selectedDs.id,
    //           );
    //           console.log(res);
    //           console.log(
    //             field.originalDataSetId !== selectedChartProp.selectedDs.id
    //               ? Boolean(!res.newTableId)
    //               : res.isMissing,
    //           );
    //           return {
    //             ...field,
    //             isMissing: res.isMissing,
    //             // field.originalDataSetId !== selectedChartProp.selectedDs.id
    //             //   ? Boolean(!res.newTableId)
    //             //   : res.isMissing,
    //           };
    //         }
    //       }),
    //     );
    //     return axis;
    //   }),
    // );
    // console.log(newChartAxes);
    if (!savedNonAggregatedCalculations) {
      console.log('Something went wrong');
      dispatch(callQueryAPI(propKey, true));
      return;
    }

    if (table.id !== selectedChartProp.selectedTable) {
      dispatch(
        setSelectedTableInTile(_propKey ?? propKey, {
          [dsUid ?? selectedChartProp.selectedDs.id]: table.id,
        }),
      );
      if (sampleRecords?.[dsUid ?? selectedChartProp.selectedDs?.id]?.[table.id]) {
        dispatch(callQueryAPI(propKey, true));
        return;
      } else {
        // For Table Switching in tile
        console.log('Something went wrong');
        value++;
        const extract =
          isExtract ??
          (selectedChartProp.selectedDs?.isExtract || selectedChartProp.selectedDs?.isFlatFileData);
        let dc_uid = dcConnId ?? selectedChartProp.selectedDs?.connectionId;
        let id = dsUid || selectedChartProp.selectedDs?.id;

        let validCalculations: any[] = savedNonAggregatedCalculations;
        let getErrorCalculations: any[] = [];
        for (const cal of savedNonAggregatedCalculations) {
          const fieldKeys = Object.keys(cal.fields);
          let hasMissing = false;
          for (const fieldKey of fieldKeys) {
            try {
              const res = await checkIfMissingColumn(
                cal.fields[fieldKey],
                selectedChartProp.selectedDs,
                tabTileProps.tablesForSelectedDataSets[selectedChartProp.selectedDs.id],
              );
              // console.log(cal.fields[fieldKey]);
              if (res.isMissing) {
                hasMissing = true;
                break;
              }
            } catch (err) {
              hasMissing = true;
              break;
            }
          }
          if (hasMissing) getErrorCalculations.push(cal);
        }

        validCalculations = validCalculations.filter(
          (cal: any) =>
            !getErrorCalculations.some((el: any) => el.displayFieldName === cal.displayFieldName),
        );

        let tableRecordsResponse = await getTableData(
          extract,
          dc_uid,
          table,
          id,
          selectedChartProp.selectedDs.workSpaceId || state?.parentId || workspaceId,
          validCalculations,
          true,
        );

        let recordsTypeResponse = await getColumnTypes(
          extract,
          dc_uid,
          id,
          table,
          selectedChartProp.selectedDs.workSpaceId || state?.parentId || workspaceId,
          validCalculations,
          true,
        );

        let filterCalculations: any = [];
        if (getErrorCalculations.length > 0) {
          filterCalculations = await getColumnTypes(
            extract,
            dc_uid,
            id,
            table,
            selectedChartProp.selectedDs.workSpaceId || state?.parentId || workspaceId,
            getErrorCalculations,
            true,
          );
          const existingCols = new Set(
            (recordsTypeResponse.data || []).map((item: any) => item.columnName),
          );

          const filteredData = (filterCalculations.data || []).filter(
            (el: any) => !existingCols.has(el.columnName),
          );

          recordsTypeResponse.data = [...recordsTypeResponse.data, ...filteredData];
          tableRecordsResponse.data;

          if (Array.isArray(filteredData) && tableRecordsResponse?.data) {
            for (const row of tableRecordsResponse.data) {
              for (const col of filteredData) {
                if (row[col.columnName] === undefined) {
                  row[col.columnName] = '';
                }
              }
            }
          }
        }
        if (!tableRecordsResponse || tableRecordsResponse.isError || !tableRecordsResponse.data) {
          // }
          showAlert(tableRecordsResponse.message || 'Error in fetching Table Data sample', 'error');
          // return;
        }
        if (recordsTypeResponse.isError || !recordsTypeResponse.data) {
          showAlert(recordsTypeResponse.message, 'error');
          // return;
        }
        let tableRecords = tableRecordsResponse.data;

        let recordsType = recordsTypeResponse.data;

        sessionStorage.setItem(
          'sampleRecords',
          JSON.stringify(
            updateSampleRecords(sampleRecords, id, table.id, tableRecords, recordsType),
          ),
        );
        dispatch(callQueryAPI(propKey, true));
      }
    }
    // if (value === 0) {
    //   dispatch(callQueryAPI(propKey, true));
    // }
  };

  const renderSelected = (selectedId: any) => {
    const sel = tabTileProps.selectedDataSetList.find((ds: any) => ds.id === selectedId);
    const checked = Boolean(sel);
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pr: 1, padding: 1 }}>
        <Typography
          noWrap
          sx={{
            fontSize: fontSize.medium,
            color: Color || (checked ? 'text.primary' : 'text.secondary'),
          }}
        >
          {sel?.datasetName ?? 'Select dataset'}
        </Typography>
      </Box>
    );
  };

  return (
    <>
      {QueryErrorMessage.length > 0 ? (
        <NotificationDialog
          onCloseAlert={() => {
            setOpenAlert(false);
            setQueryErrorMessage('');
          }}
          severity={severity}
          testMessage={QueryErrorMessage}
          openAlert={openAlert}
        />
      ) : null}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          px: 1,
          width: '100%',
        }}
      >
        <Typography
          variant="body2"
          sx={{
            pt: 0.5,
            pb: 0.5,
            px: 0.5,
            color: Color || '#404040',
            fontWeight: 600,
          }}
        >
          Switch Dataset
        </Typography>

        <FormControl fullWidth size="small">
          <Select
            value={selectedChartProp.selectedDs?.id || ''}
            onChange={handleChange}
            displayEmpty
            renderValue={renderSelected}
            MenuProps={{
              PaperProps: {
                sx: {
                  overflow: 'hidden',
                  borderRadius: 1,
                  marginLeft: '0.18rem',
                },
              },
              MenuListProps: {
                dense: true,
                sx: {
                  p: 0, // remove default list padding
                },
              },
            }}
            sx={{
              minHeight: 20,
              px: 0,
              color: Color || '#404040',
              // selected value container
              '& .MuiSelect-select': {
                display: 'flex',
                alignItems: 'center',
                py: '1px',
                px: '8px',
                fontSize: 13,
                minHeight: 20,
                justifyContent: 'flex-start',
              },
              '& .MuiSelect-icon': {
                color: Color || '#404040',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: Color || '#404040',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: Color || '#404040',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: Color || '#404040',
              },
            }}
            inputProps={{
              'aria-label': 'Switch dataset',
            }}
          >
            {tabTileProps.selectedDataSetList.map((ds: TabTilPropsSelectedDatasetList) => {
              return (
                <MenuItem
                  key={ds.id}
                  value={ds.id}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: 32,
                    px: '8px',
                    py: '2px',
                    '&:hover': {
                      backgroundColor: 'action.hover',
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: fontSize.medium,
                      lineHeight: 1.2,
                      textAlign: 'left',
                    }}
                  >
                    {ds.datasetName}
                  </Typography>
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Box>
    </>
  );
};

export default Dataset;
